
import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';

import { __t, applyTranslations } from 'utils/language';

import './settings-banner.scss';

applyTranslations(require('./settings-banner.i18n.json'));

type Props = {
  organizationId: number
};

const SettingsBanner = ({
  organizationId
}: Props) => {
  const settingsDetailsUrl = `/organizations/${organizationId}/settings/details`;

  return (
    <div className="settings-banner">
      <div className="settings-banner__title">
        {__t('settings_banner.title')}
      </div>
      <div className="settings-banner__description">
        {__t('settings_banner.description')}
      </div>
      <ActionButton
        color="primary"
        link={settingsDetailsUrl}
      >
        {__t('settings_banner.button')}
      </ActionButton>
    </div>
  );
};

export default SettingsBanner;
